import { Constants } from "src/app/core/constants";

export class SearchFilterCondition {
    Field: string;
    FilterValue: any;
    DataType: number;
    Operator: number;
    constructor(field, filterValue, dataType = Constants.FILTER_DATATYPE_NUMBER, operator = Constants.FILTER_OPERATOR_TYPE_EQUAL ) {
      this.Field = field
      this.FilterValue = filterValue,
      this.DataType = dataType,
      this.Operator = operator
    }
  }

 

